/**
 * Bannière affichée pendant une impersonnalisation (le super_admin consulte la
 * plateforme « en tant que » un autre utilisateur). Permet de revenir à son
 * compte d'origine. Le token + l'utilisateur d'origine sont stockés en
 * localStorage par la page Utilisateurs au moment de l'impersonnalisation.
 */
import type { PublicUser } from '@bcl/shared';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth-context';

export const IMPERSONATOR_KEY = 'bcl.impersonator';

type StoredImpersonator = { token: string; user: PublicUser };

function readImpersonator(): StoredImpersonator | null {
  const raw = localStorage.getItem(IMPERSONATOR_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredImpersonator;
  } catch {
    return null;
  }
}

export function ImpersonationBanner() {
  const { user, setSession } = useAuth();
  const navigate = useNavigate();
  const stored = readImpersonator();
  if (!stored || !user) return null;

  function back() {
    localStorage.removeItem(IMPERSONATOR_KEY);
    setSession(stored!.token, stored!.user);
    navigate('/admin');
  }

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 bg-amber-100 px-4 py-2 text-sm text-amber-900">
      <span>
        Vous consultez la plateforme en tant que{' '}
        <strong>
          {user.firstName} {user.lastName}
        </strong>{' '}
        — impersonnalisation active.
      </span>
      <Button size="sm" variant="outline" onClick={back}>
        Revenir à mon compte
      </Button>
    </div>
  );
}
